import React, { useState, useEffect, useCallback } from 'react';
import { colors, API, authHeaders } from '../utils/theme';
import { Modal, Button, Input } from './UI';

// Cadastro de centros de fechamento (06/10/2026) — as opções da coluna
// OPERAÇÃO da Conciliação. Os 10 de sistema (Operação X/J, Compras, Taxa de
// embarque, Pessoal, Excluído) aparecem só pra referência: moram no código,
// porque a regra automática depende deles. Os cadastrados chegam a uma linha
// por escolha à mão ou pelo centro padrão do cartão.
//
// Não confundir com "Visibilidade" (Titulares), que é quem enxerga quem.
export default function CentrosFechamentoModal({ isOpen, onClose, onChange }) {
  const [centros, setCentros] = useState([]);
  const [novo, setNovo] = useState('');
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');

  const carregar = useCallback(() => {
    fetch(`${API}/centros-fechamento?todos=1`, { headers: authHeaders() })
      .then(r => (r.ok ? r.json() : []))
      .then(d => setCentros(Array.isArray(d) ? d : []))
      .catch(() => setCentros([]));
  }, []);
  useEffect(() => { if (isOpen) { carregar(); setErro(''); } }, [isOpen, carregar]);

  const chamar = async (method, caminho, body) => {
    setSalvando(true); setErro('');
    try {
      const r = await fetch(`${API}/centros-fechamento${caminho}`, {
        method, headers: { 'Content-Type': 'application/json', ...authHeaders() },
        body: JSON.stringify(body),
      });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(d.error || `HTTP ${r.status}`);
      carregar();
      if (onChange) onChange();
      return true;
    } catch (e) { setErro(e.message); return false; }
    finally { setSalvando(false); }
  };

  const criar = async () => {
    if (!novo.trim()) return;
    if (await chamar('POST', '', { rotulo: novo.trim() })) setNovo('');
  };
  const renomear = (c) => {
    const rotulo = window.prompt(`Novo nome para "${c.rotulo}":`, c.rotulo);
    if (rotulo && rotulo.trim() && rotulo.trim() !== c.rotulo) chamar('PATCH', `/${c.codigo}`, { rotulo: rotulo.trim() });
  };
  const alternar = (c) => {
    const msg = c.ativo
      ? `Desativar "${c.rotulo}"? Some dos seletores; as linhas já classificadas nele continuam como estão.`
      : `Reativar "${c.rotulo}"?`;
    if (window.confirm(msg)) chamar('PATCH', `/${c.codigo}`, { ativo: !c.ativo });
  };

  const sistema = centros.filter(c => c.sistema);
  const cadastrados = centros.filter(c => !c.sistema);

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Operações do fechamento" width={560}>
      <div style={{ padding: 20 }}>
        <p style={{ margin: '0 0 16px', fontSize: 13, color: colors.textMuted, lineHeight: 1.5 }}>
          São as opções da coluna <strong>OPERAÇÃO</strong> da Conciliação e as colunas do fechamento na Consulta.
          Um centro cadastrado aqui vai pra uma linha quando você escolhe à mão, ou pelo
          <strong> centro padrão do cartão</strong> (em Cartões → editar).
        </p>

        <div style={{ display: 'flex', gap: 8, marginBottom: 6 }}>
          <Input value={novo} onChange={e => setNovo(e.target.value)} placeholder="Ex.: Operação Agência"
            onKeyDown={e => { if (e.key === 'Enter') criar(); }} style={{ flex: 1 }} />
          <Button onClick={criar} disabled={salvando || !novo.trim()}>Cadastrar</Button>
        </div>
        {erro && <div style={{ color: colors.danger, fontSize: 12, marginBottom: 8 }}>{erro}</div>}

        <div style={{ fontSize: 12, fontWeight: 600, color: colors.text, margin: '16px 0 6px' }}>Cadastrados</div>
        {cadastrados.length === 0 ? (
          <div style={{ fontSize: 13, color: colors.textDim, padding: '6px 0' }}>Nenhum ainda.</div>
        ) : cadastrados.map(c => (
          <div key={c.codigo} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 0',
            borderBottom: `1px solid ${colors.border}`, opacity: c.ativo ? 1 : 0.55 }}>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontWeight: 600, color: colors.text }}>{c.rotulo}{c.ativo ? '' : ' (desativado)'}</div>
              <div style={{ fontSize: 11, color: colors.textDim }}>{c.codigo}</div>
            </div>
            <Button size="sm" variant="outline" color={colors.textMuted} onClick={() => renomear(c)} disabled={salvando}>
              Renomear
            </Button>
            <Button size="sm" variant="outline" color={c.ativo ? colors.danger : colors.success}
              onClick={() => alternar(c)} disabled={salvando}>
              {c.ativo ? 'Desativar' : 'Reativar'}
            </Button>
          </div>
        ))}

        <div style={{ fontSize: 12, fontWeight: 600, color: colors.textMuted, margin: '18px 0 6px' }}>
          De sistema (não se editam — a regra automática depende deles)
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
          {sistema.map(c => (
            <span key={c.codigo} style={{ fontSize: 11, color: colors.textMuted, padding: '3px 8px',
              border: `1px solid ${colors.border}`, borderRadius: 6 }}>{c.rotulo}</span>
          ))}
        </div>
      </div>
    </Modal>
  );
}
